import React from "react";
import { InteractiveContainer } from "@jugl-web/ui-kit";

const LoginMethodButton: React.FC<{
  title: string;
  icon: React.ReactNode;
  onClick: () => void;
}> = ({ title, icon, onClick }) => (
  <InteractiveContainer
    className="group relative flex h-[50px] w-full items-center justify-center gap-2 rounded-lg bg-grey-100 p-2 text-xs text-grey-800"
    onClick={onClick}
  >
    <div className="absolute inset-0 rounded-md bg-gradient-to-r from-[#2124E4] to-[#B815C0] opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

    <div className="absolute inset-[2px] flex items-center justify-center gap-[10px] rounded-md bg-grey-100 text-xs font-normal">
      {icon}
      {title}
    </div>
  </InteractiveContainer>
);

export default LoginMethodButton;
